import { runtimeConfig } from './RuntimeConfig';

const dev = {
  API_ENDPOINT_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api/v1'
};

const prod = {
  // In production, prefer runtime config, fallback to hardcoded backend URL
  get API_ENDPOINT_URL() {
    // Check for explicit environment variable first
    if (process.env.REACT_APP_API_BASE_URL) {
      return process.env.REACT_APP_API_BASE_URL;
    }
    
    // Try runtime config
    const runtimeUrl = runtimeConfig.getApiBaseUrl();
    if (runtimeUrl && !runtimeUrl.includes(window.location.origin)) {
      return runtimeUrl;
    }
    
    // Hardcoded fallback for known deployments
    return 'https://faith-citadel-homecoming-backend-g4wtnvuymq-uc.a.run.app/api/v1';
  }
};

const test = {
  API_ENDPOINT_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api/v1'
};

const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			return dev;
	}
}

export const env = getEnv()
